import Documents, { IDocument, IDocumentApiModel } from './Document.model';

export interface IManufacturerDocuments {
  id: number;
  documentId: string;
  document: IDocument;
}

export interface IManufacturerDocumentsApiModel {
  id: number;
  documentId: string;
  document: IDocumentApiModel;
}

export default class ManufacturerDocuments implements IManufacturerDocuments {
  public readonly id: number;

  public readonly documentId: string;

  public readonly document: IDocument;

  constructor(id: number, documentId: string, document: IDocument) {
    this.id = id;
    this.documentId = documentId;
    this.document = document;
  }

  static fromApiModel(apiModel: IManufacturerDocumentsApiModel) {
    const { id, documentId } = apiModel;

    const document = Documents.fromApiModel(apiModel.document);
    return new ManufacturerDocuments(id, documentId, document);
  }

  static arrayFromApiModel(arrayApiModel: IManufacturerDocumentsApiModel[]) {
    const array = arrayApiModel.map(apiModel => {
      const { id, documentId } = apiModel;

      const document = Documents.fromApiModel(apiModel.document);

      return new ManufacturerDocuments(id, documentId, document);
    });

    return array;
  }
}
